import getAuthToken from "./getAuthToken";

export default function isInRole(role: string) {
    //let token = getJwtToken();
    let token = getAuthToken();
   
    if (token === null) {
        return false;
    }

    if (Array.isArray(token.roles)) {
        return token.roles.indexOf(role) !== -1;
    }

    return token.roles === role;
}


// WEBPACK FOOTER //
// ./ClientApp/utils/isInRole.tsx